import { Component, OnInit } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import { Router } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-validate-subscription-page',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './validate-subscription-page.component.html',
  styleUrl: './validate-subscription-page.component.scss',
})
export class ValidateSubscriptionPageComponent implements OnInit {
  constructor(
    private doctorService: DoctorService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (typeof window === 'undefined') {
      return;
    }

    this.doctorService.getDoctorRole().subscribe({
      next: (response: any) => {
        sessionStorage.setItem('role', response.role);
        this.router.navigate(['/homepage']);
      },
      error: (error: any) => {
        this.router.navigate(['/']);
      },
    });
  }
}
